var _path, _polygon, _rect, _path2, _path3, _path4, _path5, _rect2, _path6, _polygon2, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoney(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "honey3",
    d: "M65,41.42H304.34a25.14,25.14,0,0,1,25.14,25.14V81.15a10.72,10.72,0,0,1-10.72,10.72H50.59A10.72,10.72,0,0,1,39.87,81.15V66.56A25.14,25.14,0,0,1,65,41.42Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "honey3",
    points: "184.67 178.12 357.9 178.12 317.05 127.34 184.67 127.34 52.29 127.34 11.44 178.12 184.67 178.12"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "honey4",
    x: 52.29,
    y: 91.87,
    width: 264.76,
    height: 35.47
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "honey5",
    d: "M184.67,178.12H43.49A211.07,211.07,0,0,0,11.44,289.76c0,48.92,18.64,98.7,34,131.42,10.73,22.86,34.19,37.46,60,37.46H263.89c25.84,0,49.3-14.6,60-37.46,15.36-32.72,34-82.5,34-131.42a211,211,0,0,0-32-111.64Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "honey6",
    d: "M325.85,178.12H287.12a211,211,0,0,1,32.05,111.64c0,48.92-18.63,98.7-34,131.42-10.73,22.86-34.19,37.46-60,37.46h38.72c25.84,0,49.3-14.6,60-37.46,15.36-32.72,34-82.5,34-131.42A211,211,0,0,0,325.85,178.12Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "honey7",
    d: "M11.44,289.76c0,48.92,18.64,98.7,34,131.42,10.73,22.86,34.19,37.46,60,37.46H263.89c25.84,0,49.3-14.6,60-37.46,15.36-32.72,34-82.5,34-131.42a209.15,209.15,0,0,0-6.63-52.33H18.08A208.67,208.67,0,0,0,11.44,289.76Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "honey8",
    d: "M351.27,237.43H312.54a209.15,209.15,0,0,1,6.63,52.33c0,48.92-18.63,98.7-34,131.42-10.73,22.86-34.19,37.46-60,37.46h38.72c25.84,0,49.3-14.6,60-37.46,15.36-32.72,34-82.5,34-131.42A209.15,209.15,0,0,0,351.27,237.43Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "honey9",
    x: 52.29,
    y: 91.87,
    width: 264.76,
    height: 35.47
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "honey9",
    d: "M65,41.42H304.34a25.14,25.14,0,0,1,25.14,25.14V81.15a10.72,10.72,0,0,1-10.72,10.72H50.59A10.72,10.72,0,0,1,39.87,81.15V66.56A25.14,25.14,0,0,1,65,41.42Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "honey9",
    points: "184.67 178.12 357.9 178.12 317.05 127.34 184.67 127.34 52.29 127.34 11.44 178.12 184.67 178.12"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "honey9",
    d: "M184.67,178.12H43.49A211.07,211.07,0,0,0,11.44,289.76c0,48.92,18.64,98.7,34,131.42,10.73,22.86,34.19,37.46,60,37.46H263.89c25.84,0,49.3-14.6,60-37.46,15.36-32.72,34-82.5,34-131.42a211,211,0,0,0-32-111.64Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "honey9",
    d: "M11.44,289.76c0,48.92,18.64,98.7,34,131.42,10.73,22.86,34.19,37.46,60,37.46H263.89c25.84,0,49.3-14.6,60-37.46,15.36-32.72,34-82.5,34-131.42a209.15,209.15,0,0,0-6.63-52.33H18.08A208.67,208.67,0,0,0,11.44,289.76Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoney);
export default __webpack_public_path__ + "static/media/Honey.ecdd28ced1a7cdb09e9203d2d4c0f154.svg";
export { ForwardRef as ReactComponent };